import React from "react";
import { FormikProps } from "formik";
import { Box, Card, CardContent, CardMedia, Typography, Button, FormControl } from "@mui/material";
import NumberInput from "../FormFields/numberInput";
import SelectOptionGroup from "./OptionGroup";
import { useTranslation } from "react-i18next";
import LibraTranslate from "../LibreTransalate";
import './addon.style.css';
interface FormValues {
  addons: Array<any>;
}

interface ReusableFormProps {
  title: string;
  description: string;
  imageUrl: string;
  formik: FormikProps<FormValues>;
  formItems: any[];
  timeOptions: string[];
  addonObject: any;
  setFieldValue: any
}

const ReusableForm: React.FC<ReusableFormProps> = ({
  title,
  description,
  imageUrl,
  formik,
  formItems,
  timeOptions,
  addonObject,
  setFieldValue
}) => {
  const handleAddtoCart = () => {
    const addonBody = {
      calendarid: addonObject?.calendarid,
      calendarname: addonObject?.calendarname,
      desireddate: (formik.values as any)[`${addonObject?.calendarid}-timeslot-desireddate`],
      desiredtime: (formik.values as any)[`${addonObject?.calendarid}-timeslot-desiredtime`],
      timeslotid: (formik.values as any)[`${addonObject?.calendarid}-timeslot`],
      bookingMemberTypes: (formik.values as any)[`${addonObject?.calendarid}::bookingMemberTypes`],
    };
    formik.setFieldValue("addons", [...formik.values.addons, addonBody]);
    setFieldValue("addons", [...formik.values.addons, addonBody]);
  };
  const { t } = useTranslation();
  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Card sx={{ display: "flex", width: "100%" }} className="addon-card">
          <Typography variant="h5" className="addon-card-heading">
            {title}
          </Typography>
          <Box sx={{
            display: "flex", justifyContent: "space-between", flexDirection: {
              xs: "column", md: "row"
            }, rowGap: "0.865rem", columnGap: "0.67rem"
          }}>
            <CardMedia component="img" sx={{ width: 200 }} image={imageUrl} alt={title} />
            <Typography variant="body2" color="text.secondary">
              <LibraTranslate text={description} lang={'en'} />
            </Typography>
          </Box>
          <CardContent>
            <Box sx={{ mt: 2 }}>
              <FormControl fullWidth>
                <SelectOptionGroup
                  timeOptions={timeOptions as any}
                  setFieldValue={formik.setFieldValue}
                  name={`${addonObject?.calendarid}-timeslot`}
                />
              </FormControl>
            </Box>
            <Box sx={{ mt: 2 }}>
              {formItems.map((item, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", mt: 1, gap: "1rem" }}>
                  <div className="ticket-side-bar smaller">
                    <div>
                      <span className="ticket-description">
                        <LibraTranslate text={`${item?.bookingmembertype} ${item?.bookingbusinessrule}`} lang={'en'} />
                      </span>
                    </div>
                    <div className="ticket-price">
                      <div>
                        ${item?.unitprice}
                        <span className="margin-xs-left"> <LibraTranslate text={`each`} lang={'en'} /></span>
                      </div>
                    </div>
                  </div>
                  <NumberInput
                    name={item?.bookingmembertypeid}
                    setFieldValue={formik.setFieldValue}
                    formValues={formik.values}
                    addon
                    addonid={addonObject?.calendarid}
                    priceObject={item}
                    bookingMemberTypes={formItems}
                  />
                  
                </Box>
              ))}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                type="button"
                variant="outlined"
                color="primary"
                fullWidth
                sx={{color: "black", borderColor: "black"}}
                onClick={handleAddtoCart}
              >
                {t("Add To Cart")}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </form>
  );
};

export default ReusableForm;
